export default __webpack_public_path__ + "img/eZJEahYf.e51dc3b1.svg";